import * as types from './types'
import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import { displayMessages } from './common';
import { isFunction } from 'util';

export function executeQuery(page = 1, readOnly = true, next = null) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch({type: types.ADMINDB_RESETEAR_TABLA})
        const take = getState().admindb.get('take')
        const query = getState().admindb.get('query')
        const connection = getState().admindb.get('connection')

        axios.post(`${API_URL}/admin/db`, { query, connection, page, take, readOnly })
		.then((res) => {
			const fn1 = d => d({ type: types.ADMINDB_POBLAR_RESULTADOS, payload: { data: res.data, page } })
            fn1(dispatch)

            // Pass execution results to callback
            const result = {
                executionTime: res.data.executionTime,
                records: res.data.records,
                queryExecuted: res.data.queryExecuted
            };

            if (isFunction(next)) next(result)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
            if (isFunction(next)) next(null)
		})
    }
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_ADMINDB, payload: { path, value } })
	}
}


// WEBPACK FOOTER //
// ./src/actions/admindb.js